var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-sushi',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components mb-8"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-sushi',
                        to: 'to-golden_sand',
                    }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne.text)}})]),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content_01.text
                        )}}),_c('router-link',{staticClass:"text-lg",attrs:{"to":{
                                name: 'catalogue',
                                params: { slug: 'page-033' },
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphOne_Content_03.text
                            )}}),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphOne_Content_02.text
                            )}}),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Title
                                    .text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Content
                                    .text
                            )}})]),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Amélioration de la performance des groupes de Sisteron (2008 - 2014)'
                                ),
                            }}}),_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleTwo.text)}})]),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.sParagraphFour_Title
                                        .text
                                )}}),_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#81C341',
                                        '#B7DD92',
                                        '#cce5a4' ],
                                    direction: 'bottom',
                                }}})],1),_c('paragraph',{attrs:{"options":{
                                color: 'text-nandor',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .sParagraphFour_Content.text
                                )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.oImage4.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.oImage4
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}})],1)],1)],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative pt-10"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Remise en service de la Centrale d’Enguri en Géorgie, témoignage de L. Terme'
                                ),
                            }}})],1),_c('article-note',{attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphFive_Quote
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-3xl',
                                content: '',
                            },
                            margin: {},
                        }}}),_c('div',{staticClass:"mt-4"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage5
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSix_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSix_Content
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage6.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage6
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{staticClass:"flex",attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSeven_Title
                                    .text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}})],1),_c('p',{staticClass:"text-nandor text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphSeven_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('article-note',{staticStyle:{"overflow":"visible"},attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.sParagraphEight_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphEight_Quote
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl 2xl:text-3xl',
                                content: '',
                            },
                            margin: {},
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage7.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage7.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphNine_Title
                                    .text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphNine_Content
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage8.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage8
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTen_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTen_Content
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage9.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage9
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphEleven_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphEleven_Content
                                    .text
                            )}})])],1)],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }